<!-- message 全部消息 -->
<template>
  <Card class="yscCard">
    <div class="yscCardTable yscCardTabs">
      <Tabs v-model="tabSelected" :animated="true">
        <TabPane :label="(unReadMsgCount && unReadMsgCount > 0) ? tabLabel : '业务消息'" name="bizTab">
          <div style="text-align: right;">
            <Button @click="setAllRead">全部标记为已读</Button>
          </div>
          <CellGroup @on-click="readMessage" class="c_msgList">
            <Cell title=""
              :name="item.id"
              icon="ios-options"
              v-for="(item, index) in bizMsgData"
              :key="index"
              class="c_item"
              :style="item.status ? {color: '#333333', fontWeight: 600} : {color: '#666666', fontWeight: 'normal'}">
              <Badge status="error" v-if="item.status" />
              {{item && item.type ? allMsgTitles[item.type] : allMsgTitles[-1]}}  
            </Cell>
          </CellGroup>
          
          <div style="text-align: right; margin-top: 20px;">
            <Page
              :transfer="true"
              :total="pageInfo.totalCount"
              show-sizer
              @on-change="bizPageChange"
              @on-page-size-change="bizPageSizeChange" />
          </div>
        </TabPane>
        <TabPane label="系统公告（待上线）" name="sysTab" :disabled="true"></TabPane>
      </Tabs>
    </div>

    <Modal
      v-model="msgModal"
      title="消息详情"
      @on-cancel="cancelModal">
      <div v-html="msgContent"></div>
      <div slot="footer">
        <Button type="primary" @click="cancelModal">确定</Button>
      </div>
    </Modal>
  </Card>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  import RemindFetch from '@/request/remind'
  import { MessageList } from '@/utils/constants';
  
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      //这里存放数据
      return {
        tabSelected: 'bizTab',
        tabLabel: null,
        // bizMsgCols: [],
        allMsgTitles: MessageList,
        bizMsgData: [],
        unReadMsgCount: 0,
        pageInfo: {
          pageNum: 1,
          totalCount: 0,
          pageSize: 10,
        },
        msgModal: false,
        msgContent: null,
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      getMsgList () {
        this.bizMsgData = []
        let params = {
          offset: (this.pageInfo.pageNum - 1) * this.pageInfo.pageSize,
          maxResult: this.pageInfo.pageSize
        }
        RemindFetch.getMessageList(params).then((res) => {
          // console.log(res)
          if (res.success && res.body && res.body.result) {
            this.bizMsgData = res.body.result
            this.pageInfo.pageNum = res.body.pageNum
            this.pageInfo.totalCount = res.body.totalCount
          }
        })
      },
      bizPageChange (page) {
        this.pageInfo.pageNum = page
        this.getMsgList()
      },
      bizPageSizeChange (pageSize) {
        this.pageInfo.pageSize = pageSize
        this.getMsgList()
      },
      setAllRead () {
        RemindFetch.readAllMessage().then((res) => {
          if (res.success) {
            // console.log(res)
            this.getMsgList()
            this.getUnReadMsgCount()
          } else {
            this.$Notice.error({
              title: '提醒',
              desc: res.message || '请求失败'
            })
          }
        }).catch((err) => {
          this.$Notice.error({
            title: '提醒',
            desc: '请求失败'
          })
        })
      },
      readMessage (id) {
        this.msgContent = null
        let params = {
          id: id
        }
        RemindFetch.readMessage(params).then((res) => {
          // console.log(res)
          if (res.success) {
            if (res.body && res.body.length > 0) {
              this.msgModal = true
              this.msgContent = res.body[0].content
              this.getMsgList()
              this.getUnReadMsgCount()
            }
          } else {
            this.$Notice.error({
              title: '提醒',
              desc: res.message || '请求失败'
            })
          }
        }).catch((err) => {
          this.$Notice.error({
            title: '提醒',
            desc: '请求失败'
          })
        })
      },
      getUnReadMsgCount () {
        this.unReadMsgCount = 0
        RemindFetch.getUnReadMsgCount().then((res) => {
          if (res.success) {
            // console.log(res)
            if (res.message > 0) {
              this.unReadMsgCount = parseInt(res.message)
            } else {
              this.unReadMsgCount = 0
            }
          }
        })
      },
      cancelModal () {
        this.msgModal = false
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
      this.tabLabel = (h) => {
        return h('div', [
          h('span', '业务消息'),
          h('Badge', {
              props: {
                count: this.unReadMsgCount
              }
          }),
        ])
      }
      this.getMsgList()
      this.getUnReadMsgCount()
    },
  }
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.c_msgList {
  margin-top:20px;
  .c_item{
    border-bottom: 1px solid #eeeeee;
    // padding: 7px 4px;
    color: #333333;
    position: relative;
    font-size: 12px;
    &:hover{
      background-color: transparent;
      color: #666666;
    }
  }
  .ivu-badge {
    position: absolute;
    left: 0;
    top: 7px;
  }
}
</style>
<style lang='scss'>
.c_msgList {
  .ivu-cell-title{
    font-size: 12px;
  }
}
</style>
